'use client';

import Link from '@eliadmin/core/src/components/link';

import type { Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';

export function DesktopMenu({ menu }: { menu: Menu[] }) {
  return (
    <div
      className={cn(
        'custom-container',
        'hidden grid-cols-2 gap-x-8 gap-y-16 sm:grid lg:grid-cols-4 xl:gap-x-16',
      )}
    >
      {menu.map(item => (
        <div
          key={item.name}
          className="col-span-1 flex w-full flex-col items-start justify-start gap-6"
        >
          <Heading title={item.name} tag="h5" as="h2" className={{ title: 'text-white' }} />
          <div className="flex w-full flex-col items-start justify-start gap-2">
            {item.fields.map(field => (
              <Link
                key={field.name}
                href={getSafeHref(field?.path ?? '#')}
                className="tracking-tight text-white"
              >
                {field.name}
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
